export default {
  bind(el, bindings, vnode) {
    window.addEventListener('scroll', () => {
      let offset = window.pageYOffset
      let scrollLength = 200
      if (offset >= scrollLength) {
        el.classList.add('is-active')
      } else {
        el.classList.remove('is-active')
      }
    })
    
    el.addEventListener('click', () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/directives/up-button/up-button.js